import { registerDecorator, ValidatorConstraint } from 'class-validator';
import { isString } from '@worksolutions/utils';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function IsSorting(sortingEnum, validationOptions) {
    return (object, propertyName)=>{
        registerDecorator({
            target: object.constructor,
            propertyName,
            constraints: [
                Object.values(sortingEnum)
            ],
            options: validationOptions,
            validator: IsSortingValidator
        });
    };
}
const isSortingValidatorName = "CustomIsSorting";
function getIsSortingSchema([sortingEnumValues]) {
    return {
        type: "string",
        enum: sortingEnumValues.flatMap((key)=>[
                key,
                `-${key}`
            ])
    };
}
class IsSortingValidator {
    validate(value, args) {
        const sortingNames = args.constraints[0];
        if (value === undefined) return true;
        if (!isString(value)) return false;
        if (sortingNames.includes(value[0] === "-" ? value.slice(1) : value)) return true;
        return false;
    }
}
IsSortingValidator = _ts_decorate([
    ValidatorConstraint({
        name: isSortingValidatorName
    })
], IsSortingValidator);

export { IsSorting as I, getIsSortingSchema as g, isSortingValidatorName as i };
//# sourceMappingURL=isSorting_chunkExport-BeZP1lO3.mjs.map
